import React from "react";
import { createStep, useForm } from "@/Components/formik-steps";
import Preview from "@/Components/steps/Preview";

function CompletedStep() {
  const { values } = useForm();

  return (
    <div className="inline-flex flex-col w-full items-center">
      <svg
        className="mb-[24px]"
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.5 77.5C19.8225 77.5 3 60.6775 3 40C3 19.3225 19.8225 2.5 40.5 2.5C61.1775 2.5 78 19.3225 78 40C78 60.6775 61.1775 77.5 40.5 77.5ZM40.5 7.5C22.58 7.5 8 22.08 8 40C8 57.92 22.58 72.5 40.5 72.5C58.42 72.5 73 57.92 73 40C73 22.08 58.42 7.5 40.5 7.5ZM37.2675 51.7675L59.7675 29.2675C60.745 28.29 60.745 26.71 59.7675 25.7325C58.79 24.755 57.21 24.755 56.2325 25.7325L35.5 46.465L27.2675 38.2325C26.29 37.255 24.71 37.255 23.7325 38.2325C22.755 39.21 22.755 40.79 23.7325 41.7675L33.7325 51.7675C34.22 52.255 34.86 52.5 35.5 52.5C36.14 52.5 36.78 52.255 37.2675 51.7675Z"
          fill="#B71922"
        />
      </svg>

      <h1 className="mb-[36px] text-[#070707] text-center text-4xl font-bold leading-[normal] tracking-[0.36px]">
        Jouw afspraak is ingepland {values.first_name}
      </h1>

          <div className="w-full max-w-[669px]">
          <Preview />
          </div>
      <a
        href="/"
        className="bg-red-700 rounded-[10px] text-white py-2 px-4 w-[200px] text-center"
      >
        Terug naar website
      </a>
    </div>
  );
}

export default createStep({
  component: <CompletedStep />,
});
